import { useContentBriefBlockHandlers } from './use-content-brief-block-handlers.hook'
import { useContentBriefBlockState } from './use-content-brief-block-state.hook'

export interface UseContentBriefBlockProps {
  comment?: string
  onCommentChange: (comment: string | undefined) => void
}

export interface UseContentBriefBlockReturn {
  isEditing: boolean
  draftComment: string
  textareaRef: React.RefObject<HTMLTextAreaElement | null>
  hasComment: boolean
  handleBlockClick: () => void
  handleSave: () => void
  handleCancel: () => void
  handleDelete: () => void
  handleKeyDown: (e: React.KeyboardEvent) => void
  handleBlockKeyDown: (e: React.KeyboardEvent) => void
  setDraftComment: (value: string) => void
}

export const useContentBriefBlock = ({
  comment,
  onCommentChange,
}: UseContentBriefBlockProps): UseContentBriefBlockReturn => {
  const state = useContentBriefBlockState({ comment })
  const handlers = useContentBriefBlockHandlers({
    comment,
    draftComment: state.draftComment,
    isEditing: state.isEditing,
    setIsEditing: state.setIsEditing,
    setDraftComment: state.setDraftComment,
    onCommentChange,
  })

  return {
    ...state,
    ...handlers,
  }
}
